import { Component } from "@angular/core";

@Component({
   selector: "my-cloud-erp-sso",
   template: "<div></div>"
})
export class CloudErpSsoComponent {}
